/* Ruts Atelier — movimiento: reveal al scroll + parallax leve.
   El reveal SIEMPRE se ejecuta (fade); el parallax respeta prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var items = document.querySelectorAll('[data-ruts-reveal]:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    document.querySelectorAll('[data-ruts-reveal-group]').forEach(function (group) {
      group.querySelectorAll('[data-ruts-reveal]').forEach(function (el, i) {
        el.style.transitionDelay = (i * 0.12) + 's';
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -12% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;
    var bgs = document.querySelectorAll('[data-ruts-parallax-bg]');
    if (!bgs.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      bgs.forEach(function (bg) {
        var rect = bg.parentElement.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        bg.style.transform = 'translate3d(0,' + (progress * -34).toFixed(1) + 'px,0) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init() { initReveal(); initParallax(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { initReveal(); initParallax(); });
})();
